// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_9a-0";
export var orangeButton = "_9a-1";